module.exports = __webpack_public_path__ + "static/img/z7.f6a1eb8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/z7.png
// module id = W7Qe
// module chunks = 0